import { render, staticRenderFns } from "./PromotionEdit.vue?vue&type=template&id=329c0deb&scoped=true"
import script from "./PromotionEdit.vue?vue&type=script&lang=js"
export * from "./PromotionEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "329c0deb",
  null
  
)

export default component.exports